// Long assessment names broke page headers and tables. Show at most `max`
// characters, ending on a whole word where one is close, and put the full
// name in a title attribute wherever this is used.
export function shortName(value, max = 40) {
  const text = value === null || value === undefined ? '' : String(value).trim()
  if (text.length <= max) return text
  const cut = text.slice(0, max - 1)
  const space = cut.lastIndexOf(' ')
  return (space > max * 0.6 ? cut.slice(0, space) : cut).replace(/[\s,.;:(–-]+$/, '') + '…'
}
